import {inject} from '@angular/core';
import {Observable, of} from 'rxjs';
import { Store } from '@ngrx/store';
import {catchError, tap} from 'rxjs/operators';
import {ResolveFn} from '@angular/router';

import {RetrieveUnitsFailed, RetrieveLookUpUnitsSuccessful} from '../actions/lookup.action';
import {getState} from '../shared/utils';
import {selectProjectSettings} from '../auth/selectors';
import {ProjectSetting} from '../../../common/project-setting.model';
import {Unit} from '../../../common/unit.model';
import {UnitsDataService} from '../units/services/unit.data.service';

export const UnitResolver: ResolveFn<Unit[]> = (): Observable<Unit[]> => {
  const unitsDataService: UnitsDataService = inject(UnitsDataService);
  const store: Store = inject(Store);
  const {projectId} = getState<ProjectSetting>(store, selectProjectSettings);
  return unitsDataService.retrieveUnits(projectId).pipe(
    catchError(() => {
      store.dispatch(RetrieveUnitsFailed());
      return of();
    }),
    tap((units: Unit[]) => store.dispatch(RetrieveLookUpUnitsSuccessful(units)))
  );
};
